import { useEffect } from 'react'
import {
  hasInitialRouteRendered,
  markInitialRouteRendered,
} from 'shared/lib/initialRouteRenderState'
import { SplashScreen } from './SplashScreen'

export function InitialPagePendingScreen() {
  useEffect(() => {
    markInitialRouteRendered()
  }, [])

  if (hasInitialRouteRendered()) return null

  return <SplashScreen />
}
